import { motion } from "framer-motion";
import { MIK_LOGO } from "@/constants/config";

export const Header = () => (
  <motion.header
    initial={{ opacity: 0, y: -14 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, ease: "easeOut" }}
    style={{ top: "calc(40px + env(safe-area-inset-top, 0px))" }}
    className="fixed inset-x-0 z-30 flex items-center justify-center py-4"
  >
    <div className="flex items-center gap-2.5 rounded-full border border-white/10 bg-black/40 px-4 py-2 backdrop-blur-md">
      <img
        src={MIK_LOGO}
        alt="MIK Education logo"
        className="h-6 w-auto object-contain"
        loading="eager"
      />
      <span className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-white/80">
        MIK Education
      </span>
    </div>
  </motion.header>
);
